import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from 'apps/new-web/views/component';
import PostLoginNavigation from './post-login-navigation';

export class PureHeader extends BaseComponent {
  static get propTypes() {
    return {
      user: PropTypes.object,
      subNavCta: PropTypes.bool,
      assumedUserId: PropTypes.string,
    };
  }

  render() {
    return (
      <div className="top-nav-container">
        <header className="header-component">{this.renderNavigation()}</header>
      </div>
    );
  }

  renderNavigation() {
    const { subNavComponent, user, assumedUserId } = this.props;
    return (
      <PostLoginNavigation
        user={user}
        subNavComponent={subNavComponent}
        assumedUserId={assumedUserId}
      />
    );
  }
}

export default connect((state) => {
  return {
    user: state.user,
    layout: state.layout,
  };
})(PureHeader);
